<ndt-compact-register-two-column
  [name]="name"
  [totalCount]="totalCount"
  [callState]="callState"
  [hasNextPage]="hasNextPage"
  [pagingCallState]="pagingCallState"
  [pluralName]="pluralName"
  [showCreate]="schedulePrivileges?.canAdd"
  (create)="onCreate()"
  (quickFilterChange)="onQuickFilterChange($event)"
  (loadMore)="onLoadMore()"
  >
  <lcs-responsive-table [columns]="columns">
    <table lcs-table [dataSource]="dataSource">
      <tr lcs-row *lcsResponsiveRowDef></tr>
      <ng-container lcsColumnDef="name" width="4">
        <td
          lcs-cell
          *lcsCellDef="let schedule"
          [id]="'cell-' + schedule.scheduleId"
          (click)="onScheduleClick(schedule.scheduleId)"
          class="row-item"
          [ngClass]="{ highlighted: currentSelectedId === schedule.scheduleId }"
          >
          <div class="flex-container">
            <a class="schedule-overflow-hidden">
              {{ schedule.name }}
            </a>
            <div class="context-actions">
              @if (canDelete() || schedulePrivileges?.canEdit) {
                <button
                  type="button"
                  mat-button
                  [matMenuTriggerFor]="scheduleMenu"
                  [matMenuTriggerData]="{ $implicit: schedule }"
                  aria-label="Schedule Actions"
                  matTooltip="More Actions"
                  id="schedule-detail-more-actions"
                  >
                  <mat-icon>more_horiz</mat-icon>
                </button>
              }
            </div>
          </div>
        </td>
      </ng-container>
    </table>
    <mat-menu #scheduleMenu="matMenu">
      <ng-template matMenuContent let-schedule>
        @if (schedulePrivileges?.canEdit) {
          <button
            mat-menu-item
            type="button"
            (click)="onSaveAsClick(schedule)"
            id="schedule-save-as"
            >
            Save As
          </button>
        }
        @if (canDelete()) {
          <button mat-menu-item type="button" (click)="onDeleteClick()" id="schedule-delete">
            Delete
          </button>
        }
      </ng-template>
    </mat-menu>
  </lcs-responsive-table>
</ndt-compact-register-two-column>
